import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import "./PackageDetail.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => {
  return (
    <div className="slider-arrow next" onClick={onClick}>
      <FaChevronRight />
    </div>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <div className="slider-arrow prev" onClick={onClick}>
      <FaChevronLeft />
    </div>
  );
};

const PackageDetail = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">
      {/* ================= TOP BANNER ================= */}
      {/* ================= HERO BANNER ================= */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/kathmandu-banner.avif')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Kathmandu Spiritual Tour</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Kathmandu Sightseeing Package
            </p>

            <div className="hero-price">
              Starting From <span>₹18,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">
        {/* ================= SLIDER + FORM ================= */}
        <Row className="mb-4">
          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/kathmandu-banner.avif" alt="" />
                <img src="/Images/tour/kathmandu-banner1.jpg" alt="" />
                <img src="/Images/tour/kathmandu-banner2.avif" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT ENQUIRY FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹18,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* ================= MAIN CONTENT ================= */}
        <Row>
          <Col lg={8}>
            {/* HEADER */}
            <div className="package-header">
              <h1>Kathmandu Spiritual Tour</h1>
              <p>3 Nights / 4 Days • Kathmandu Sightseeing</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Pashupatinath Temple Darshan</Col>
                <Col md={6}>✔ Boudhanath Stupa Visit</Col>
                <Col md={6}>✔ Swayambhunath (Monkey Temple)</Col>
                <Col md={6}>✔ Kathmandu Heritage City Tour</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Discover the spiritual and cultural heart of Nepal with
                Kathmandu Tour Package. Explore ancient temples, UNESCO World
                Heritage Sites, vibrant local markets and sacred Hindu &
                Buddhist pilgrimage destinations.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Kathmandu</Accordion.Header>
                  <Accordion.Body>
                    Arrival at Kathmandu Airport, hotel transfer and evening
                    visit to Pashupatinath Temple for Aarti Darshan.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Kathmandu Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Swayambhunath Temple, Boudhanath Stupa, Kathmandu
                    Durbar Square and local markets.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Bhaktapur & Patan Tour
                  </Accordion.Header>
                  <Accordion.Body>
                    Explore Bhaktapur Durbar Square, Patan city and traditional
                    Nepali architecture.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>Day 4 – Departure</Accordion.Header>
                  <Accordion.Body>
                    Breakfast and airport drop with divine memories.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>

            {/* Inclusion Exclusion */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Airport Transfers</li>
                    <li>Sightseeing</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                    <li>Helicopter Charges</li>
                  </ul>
                </Col>
              </Row>
            </div>

            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/kathmandu-banner.avif" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/kathmandu-banner1.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/kathmandu-banner2.avif" alt="" />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PackageDetail;
